import Modal from '@/components/modal/modal.vue'
import MobileModal from '@/components/modal/MobileModal.vue'
import LogoMobileModal from '@/components/modal/LogoMobileModal.vue'

function createComponent (component, componentName, store, data) {
  const on = {
    close: () => {
      store.dispatch('removeGlobalLayer', componentName)
    },
    ...data.on || {}
  }

  const com = {
    name: componentName,
    render (h) {
      return h(component, { props: { data }, on })
    }
  }

  store.dispatch('addGlobalLayer', com)
}

export function createModal (store, data) {
  createComponent(Modal, 'Modal', store, data)
}

export function createMobileModal (store, data) {
  createComponent(MobileModal, 'MobileModal', store, data)
}

export function createLogoMobileModal (store, data) {
  createComponent(LogoMobileModal, 'LogoMobileModal', store, data)
}
